import { theme as J } from "@qga/roo-ui";
import Qe from "lodash/merge";
import { rem as g } from "polished";
import { person as He } from "@qga/roo-ui/icons";
import { jsx as t, jsxs as i, Fragment as v } from "react/jsx-runtime";
import c from "@emotion/styled";
import { Box as y, Flex as u, Image as qe, Text as w, Link as N, Icon as A, Container as z, OutlineButton as Fe, NakedButton as T, Hide as X, RegionLinks as Pe, LoadingIndicator as ie, Label as Ue, Select as Re, Heading as Q, Input as U, Button as se } from "@qga/roo-ui/components";
import { noop as S, compact as le, isArray as ce, last as We, toNumber as Be, head as Ye } from "lodash";
import { memo as E, useEffect as x, useReducer as de, useMemo as ue, useRef as H, useCallback as R, createContext as Ve, useContext as Ge, Fragment as I, useState as Ze, forwardRef as he } from "react";
import { themeGet as a } from "styled-system";
import { qantasHotels as pe } from "@qga/roo-ui/logos";
import { baggage as K } from "@qga/roo-ui/assets";
import { css as O, keyframes as me } from "@emotion/core";
import { FocusWithin as Je } from "react-focus-within";
import Xe from "lodash/isEmpty";
import { useInView as Ke } from "react-intersection-observer";
import et from "lodash/pick";
import { useForm as tt } from "react-hook-form";
import { addBusinessDays as nt, format as at } from "date-fns";
const fe = "https://www.qantas.com/au/en/book-a-trip/hotels-and-airbnb.html", f = "https://www.qantas.com", ge = "https://www.qantas.com/hotels", ye = `${f}/hotels/search/list`, rt = `${f}/hotels/australia`, be = `${f}/hotels/deals`, Me = `${f}/hotels/manage/bookings`, we = `${f}/holidays/deals`, ke = `${f}/hotels/contact-us`, Ne = `${f}/hotels/faqs`, De = `${f}/hotels/australia`, ot = "https://www.qantas.com/au/en/support/privacy-and-security.html", it = "https://www.qantas.com/au/en/support/terms-of-use.html", st = "https://www.qantas.com/au/en/support/privacy-and-security.html", lt = "https://www.qantas.com/au/en/support/terms-of-use.html", ct = "https://www.qantas.com/fflyer/dyns/joinff", dt = "https://www.qantas.com/au/en/frequent-flyer/my-account.html", ut = "https://www.qantas.com/au/en/frequent-flyer/my-account/profile.html", ht = "https://www.qantas.com/au/en/frequent-flyer/my-account/points-activity.html", pt = "40px", mt = "https://frontend.qantas.com/widgets/universal-nav/current/app.js", V = E(
  ({
    variant: e = "desktop",
    hidden: n = !1,
    minHeight: r = pt,
    siteId: o = "hotel",
    ...l
  }) => {
    const s = e === "mobile" ? { className: "global_features_mobile" } : {};
    return x(() => {
      yt();
    }, []), /* @__PURE__ */ t(
      ft,
      {
        hidden: n,
        "data-testid": "qantas-universal-nav-wrapper",
        minHeight: r,
        ...l,
        children: /* @__PURE__ */ t(
          "div",
          {
            ...s,
            "data-testid": "qantas-universal-nav-target",
            "data-widget-type": "global_features_navigation",
            children: /* @__PURE__ */ t(
              "script",
              {
                "data-testid": "qantas-universal-nav-config",
                type: "qantas/widget",
                dangerouslySetInnerHTML: {
                  __html: `{"environment": "production", "siteId": "${o}"}`
                }
              }
            )
          }
        )
      }
    );
  }
);
V.displayName = "QantasUniversalNav";
const ft = c(y)`
  & .global_features_navigation {
    z-index: 0;
  }

  @media print {
    display: none;
  }
`, gt = () => !!document.querySelectorAll('[data-testid="qantas-universal-nav-script"]').length, yt = () => {
  if (gt())
    typeof Event == "function" && document.dispatchEvent(new Event("universalNav.reload"));
  else {
    const e = document.createElement("script");
    e.setAttribute("data-testid", "qantas-universal-nav-script"), e.type = "text/javascript", e.src = mt, document.body.appendChild(e);
  }
}, Le = {
  isNavMenuOpen: !1,
  isQffMenuOpen: !1
};
function bt(e = Le, n) {
  switch (n.type) {
    case "toggleNavMenu":
      return {
        ...e,
        isNavMenuOpen: n.payload ?? !e.isNavMenuOpen,
        isQffMenuOpen: !1
      };
    case "toggleQffMenu":
      return {
        ...e,
        isNavMenuOpen: !1,
        isQffMenuOpen: n.payload ?? !e.isQffMenuOpen
      };
    default:
      return e;
  }
}
function Mt(e) {
  return {
    toggleNavMenu: (n) => e({ type: "toggleNavMenu", payload: n }),
    toggleQffMenu: (n) => e({ type: "toggleQffMenu", payload: n })
  };
}
function wt() {
  const [e, n] = de(bt, Le), r = ue(() => Mt(n), [n]);
  return [e, r];
}
const kt = ({
  children: e,
  desktopLinks: n,
  phoneLinks: r,
  qffAuthData: o,
  qffLinks: l,
  onDismissLoginTooltip: s,
  displayLoginTooltip: d,
  queryString: h,
  ...p
}) => {
  const [b, k] = wt(), m = H(p);
  x(() => {
    m.current = p;
  });
  const D = R(() => m.current.onClickLogin(), []), M = R(
    () => m.current.onClickLogout(),
    []
  ), $ = R(
    (Z) => m.current.onInteraction(Z),
    []
  ), P = ue(
    () => ({
      ...b,
      ...k,
      desktopLinks: n,
      phoneLinks: r,
      qffAuthData: o,
      qffLinks: l,
      onClickLogin: D,
      onClickLogout: M,
      onInteraction: $,
      onDismissLoginTooltip: s,
      displayLoginTooltip: d,
      queryString: h
    }),
    [
      b,
      k,
      n,
      r,
      o,
      l,
      D,
      M,
      $,
      s,
      d,
      h
    ]
  );
  return /* @__PURE__ */ t(Ae.Provider, { value: P, children: e });
}, Ae = Ve({
  desktopLinks: [],
  phoneLinks: [],
  qffLinks: [],
  qffAuthData: { isAuthenticated: !1 },
  isNavMenuOpen: !1,
  isQffMenuOpen: !1,
  toggleNavMenu: S,
  toggleQffMenu: S,
  onClickLogin: S,
  onClickLogout: S,
  onInteraction: S,
  onDismissLoginTooltip: S,
  displayLoginTooltip: !0,
  queryString: void 0
}), L = () => Ge(Ae), Se = ({ arrowDirection: e }) => {
  const {
    onDismissLoginTooltip: n = () => {
    },
    onInteraction: r,
    qffAuthData: o,
    onClickLogin: l,
    displayLoginTooltip: s
  } = L(), d = () => {
    n(), r({ type: "Login tooltip", value: "LoginTooltip Dismissed" });
  };
  return !s || o.isAuthenticated ? null : /* @__PURE__ */ i(
    Nt,
    {
      width: ["100%", "100%", "350px"],
      mt: [-3, -3, 0],
      mr: [0, 0, -3],
      "data-testid": "login-tooltip",
      flexDirection: ["column", "column", "row"],
      children: [
        e === "up" && /* @__PURE__ */ t(Dt, {}),
        /* @__PURE__ */ i(
          At,
          {
            justifyContent: ["space-between", "space-between", "center"],
            alignItems: "center",
            children: [
              /* @__PURE__ */ i(u, { justifyContent: "center", alignItems: "center", children: [
                /* @__PURE__ */ t(y, { display: "block", width: g("86px"), children: /* @__PURE__ */ t(
                  qe,
                  {
                    alt: K,
                    src: K,
                    height: g("46px"),
                    width: "100%",
                    pr: 4
                  }
                ) }),
                /* @__PURE__ */ i(w, { display: "block", fontSize: "base", children: [
                  /* @__PURE__ */ i(
                    N,
                    {
                      mr: 1,
                      underline: !0,
                      color: "inherit",
                      role: "button",
                      onClick: l,
                      "data-testid": "login-link",
                      children: [
                        "Login",
                        " "
                      ]
                    }
                  ),
                  "to access incredible deals for members!"
                ] })
              ] }),
              /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(
                A,
                {
                  name: "close",
                  ml: 8,
                  mr: 0,
                  size: 18,
                  color: "greys.dusty",
                  onClick: d,
                  "data-testid": "close-icon"
                }
              ) })
            ]
          }
        ),
        e === "right" && /* @__PURE__ */ t(Lt, {})
      ]
    }
  );
}, Nt = c(u)`
  z-index: ${a("zIndices.stickyNavigation")};
`, Dt = c(y)`
  z-index: ${a("zIndices.loginToolTip")};
  margin-bottom: -1px;
  align-self: flex-end;
  margin-right: ${a("space.8")};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid ${a("colors.white")};

  ${a("mediaQueries.1")} {
    border-bottom: 10px solid ${a("colors.snow")};
  }
`, Lt = c(y)`
  align-self: center;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid ${a("colors.white")};
`, At = c(u)`
  z-index: ${a("zIndices.stickyCampaignMessaging")};
  height: 74px;
  padding: ${a("space.4")};
  background: linear-gradient(-180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 35%, #E6E6E6 100%);
  border-top: 1px solid ${a("colors.greys.alto")};
  border-bottom: 1px solid ${a("colors.greys.alto")};
  box-shadow: ${a("shadows.hover")};

  ${a("mediaQueries.1")} {
    border-top: 0px;
    border-radius: 0 0 0 ${a("radii.default")};
  }
}
`, St = ({
  menuItems: e = [],
  onClick: n
}) => /* @__PURE__ */ t(z, { children: /* @__PURE__ */ t(xt, { children: e.map(
  ({ children: r, submenu: o = [], trackingName: l, ...s }, d) => /* @__PURE__ */ i(It, { children: [
    !!s.href && /* @__PURE__ */ t(y, { onClick: () => n(l), children: /* @__PURE__ */ i($t, { ...s, "data-testid": "title-with-link", children: [
      /* @__PURE__ */ t(w, { fontSize: "base", mr: 3, children: r }),
      /* @__PURE__ */ t(A, { name: "chevronRight", color: "greys.steel", size: 16 })
    ] }) }),
    !s.href && /* @__PURE__ */ t(Ct, { "data-testid": "text-only-title", children: r }),
    !Xe(o) && /* @__PURE__ */ t(u, { flexDirection: "column", "data-testid": "dropdown-sub-lists", children: o.map((h, p) => /* @__PURE__ */ t(
      y,
      {
        onClick: () => n(h.trackingName),
        children: /* @__PURE__ */ t(jt, { ...h, mt: 2 })
      },
      p
    )) })
  ] }, d)
) }) }), xt = c(u)`
  position: absolute;
  box-shadow: ${a("shadows.modal")};
  z-index: ${a("zIndices.modal")};
  width: ${g("500px")};
  margin-left: -${a("space.3")};
  border: solid 1px ${a("colors.greys.alto")};
  border-top: 0;
  background-color: ${a("colors.white")};
`, It = c(u)`
  width: 100%;
  flex-direction: column;
  padding: ${a("space.6")};
  color: ${a("colors.greys.steel")};
`, $t = c(N)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px ${a("colors.greys.porcelain")};
  padding-bottom: ${a("space.2")};
  color: inherit;

  &:hover {
    color: ${a("colors.brand.primary")};
  }
`, Ct = c(w)`
  font-size: ${a("fontSizes.base")};
  border-bottom: solid 1px ${a("colors.greys.porcelain")};
  padding-bottom: ${a("space.2")};
  color: inherit;
`, jt = c(N)`
  font-size: ${a("fontSizes.sm")};
  color: inherit;

  &:hover {
    color: ${a("colors.brand.primary")};
  }
`, vt = () => {
  const { desktopLinks: e, onInteraction: n, queryString: r } = L();
  return /* @__PURE__ */ t(
    xe,
    {
      desktopLinks: e,
      onInteraction: n,
      queryString: r
    }
  );
}, xe = E(
  ({ desktopLinks: e, onInteraction: n, queryString: r }) => {
    const o = (l) => n({
      type: "Site Navigation",
      value: `${l} Selected`
    });
    return /* @__PURE__ */ t(Tt, { children: /* @__PURE__ */ t(z, { children: /* @__PURE__ */ t(zt, { children: e.map(({ trackingName: l, usesQueryParams: s, ...d }) => d.dropdown ? /* @__PURE__ */ t(Je, { children: ({ focusProps: h, isFocused: p }) => /* @__PURE__ */ i(
      ee,
      {
        ...h,
        className: p ? "open-dropdown-menu" : "",
        children: [
          /* @__PURE__ */ i(te, { ...d, children: [
            d.children,
            /* @__PURE__ */ t(A, { name: "expandMore", size: 18, ml: 2 })
          ] }),
          /* @__PURE__ */ t(y, { className: "nav-dropdown-menu", children: /* @__PURE__ */ t(
            St,
            {
              menuItems: d.dropdown,
              onClick: o
            }
          ) })
        ]
      }
    ) }, l) : /* @__PURE__ */ t(ee, { children: /* @__PURE__ */ t(
      te,
      {
        onClick: () => o(l),
        ...d,
        href: `${d.href}${s && r ? `?${r}` : ""}`,
        to: `${d.to}${s && r ? d.hasGclid ? `&${r}` : `?${r}` : ""}`
      }
    ) }, l)) }) }) });
  }
);
xe.displayName = "NavigationLinksMemo";
const zt = c.ul`
  display: flex;
  margin: 0;
  padding: 0;
  list-style-type: none;
`, ee = c.li`
  .nav-dropdown-menu {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
    z-index: ${a("zIndices.navigationDropdown")};
    position: absolute;
  }

  &:hover,
  &:focus,
  &.open-dropdown-menu {
    background-color: ${a("colors.white")};

    > a,
    button {
      color: ${a("colors.brand.primary")};
    }

    .nav-dropdown-menu {
      visibility: visible;
      opacity: 1;
    }
  }
`, te = c(N)`
  white-space: nowrap;
  font-size: ${a("fontSizes.header.base")};
  padding: ${a("space.5")} ${a("space.5")};
  width: 100%;
  color: ${a("colors.white")};

  &:hover {
    background-color: ${a("colors.white")};
    color: ${a("colors.brand.primary")};
  }
`, Tt = c(u)`
  background-color: ${a("colors.greys.charcoal")};

  color: ${a("colors.white")};
`, Et = ({ title: e, firstName: n, lastName: r }) => `${e} ${n} ${r}`, Ot = (e) => e.replace(/\B(?=(\d{3})+(?!\d))/g, ","), G = (e, n) => {
  const o = (n === void 0 ? e.toString() : Number(e).toFixed(n)).split(".");
  return le([Ot(o[0]), o[1]]).join(".");
}, _t = () => {
  const { qffAuthData: e } = L();
  return /* @__PURE__ */ t(Qt, { ...e });
}, Qt = ({
  isAuthenticated: e,
  title: n,
  firstName: r,
  lastName: o,
  membershipTier: l,
  pointsBalance: s
}) => e ? /* @__PURE__ */ i(u, { alignItems: "center", "data-testid": "auth-details-wrapper", children: [
  /* @__PURE__ */ i(
    u,
    {
      flexDirection: "column",
      color: "white",
      justifyContent: "flex-start",
      ml: 2,
      children: [
        /* @__PURE__ */ t(
          _,
          {
            fontSize: "header.sm",
            fontWeight: "bold",
            "data-hj-suppress": !0,
            pr: 2,
            "data-testid": "member-name",
            children: le([n, r, o]).join(" ")
          }
        ),
        /* @__PURE__ */ i(u, { children: [
          /* @__PURE__ */ i(_, { "data-testid": "member-points-balance", children: [
            G(s),
            " points"
          ] }),
          /* @__PURE__ */ t(_, { mx: 1, children: "-" }),
          /* @__PURE__ */ t(_, { "data-testid": "member-tier", children: l })
        ] })
      ]
    }
  ),
  /* @__PURE__ */ t(A, { name: "expandMore", ml: 4 })
] }) : null, _ = (e) => /* @__PURE__ */ t(w, { fontSize: "header.sm", fontWeight: "bold", ...e }), Ht = c(u)`
  padding-bottom: ${a("space.4")};
  border-bottom: 2px solid ${a("colors.greys.porcelain")};
`, qt = () => {
  const { qffLinks: e, onInteraction: n } = L();
  return /* @__PURE__ */ t(u, { py: 5, flexDirection: "column", children: e == null ? void 0 : e.map(({ trackingName: r, ...o }) => /* @__PURE__ */ t(
    Ft,
    {
      onClick: () => n({
        type: "QFF Login Dropdown",
        value: `${r} Selected`
      }),
      ...o
    },
    r
  )) });
}, Ft = c(N)`
  color: ${a("colors.greys.charcoal")};
  padding-left: ${a("space.5")};
  margin-bottom: ${a("space.2")};
`, Pt = () => {
  const {
    firstName: e = "",
    lastName: n = "",
    memberId: r = "",
    membershipTier: o = "",
    pointsBalance: l = ""
  } = L().qffAuthData;
  return /* @__PURE__ */ i(Ut, { children: [
    /* @__PURE__ */ t(u, { mb: 2, children: /* @__PURE__ */ t(Rt, { children: /* @__PURE__ */ t(A, { name: "person", size: 16, pb: "2px" }) }) }),
    /* @__PURE__ */ i(
      u,
      {
        flexWrap: "wrap",
        textAlign: "center",
        "data-testid": "full-name-member-id",
        children: [
          e,
          " ",
          n,
          " (",
          r,
          ")"
        ]
      }
    ),
    /* @__PURE__ */ i(u, { "data-testid": "points-balance", children: [
      G(l),
      " points"
    ] }),
    /* @__PURE__ */ t(u, { "data-testid": "membership-tier", children: o })
  ] });
}, Ut = c(u)`
  flex-direction: column;
  background-color: ${a("colors.brand.primary")};
  color: ${a("colors.white")};
  align-items: center;
  font-size: ${a("fontSizes.header.base")};
  padding: ${a("space.5")} ${a("space.2")};
`, Rt = c(u)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px white solid;
  align-items: center;
  justify-content: center;
`, Ie = () => {
  const { onClickLogout: e, onInteraction: n, toggleQffMenu: r } = L();
  return /* @__PURE__ */ i(I, { children: [
    /* @__PURE__ */ t(w, { fontSize: "header.base", pl: 5, py: 5, children: "Frequent Flyer Login" }),
    /* @__PURE__ */ t(Pt, {}),
    /* @__PURE__ */ t(qt, {}),
    /* @__PURE__ */ t(Ht, { children: /* @__PURE__ */ t(
      Wt,
      {
        onClick: () => {
          n({ type: "QFF Login Dropdown", value: "Log Out Selected" }), r(!1), e();
        },
        variant: "primary",
        "data-testid": "logout-button",
        children: "LOG OUT"
      }
    ) })
  ] });
}, Wt = c(Fe)`
  margin: 0 ${a("space.5")};
  width: 100%;
`, Bt = () => {
  const e = L(), { isAuthenticated: n } = e.qffAuthData;
  return /* @__PURE__ */ i(y, { children: [
    /* @__PURE__ */ i(
      Jt,
      {
        isAuthenticated: n,
        isOpen: e.isQffMenuOpen,
        role: "button",
        onClick: Yt(e),
        "data-testid": n ? "qff-menu-tab" : "qff-login-tab",
        children: [
          !n && "Log in",
          n && e.isQffMenuOpen && /* @__PURE__ */ t(Xt, {}),
          n && !e.isQffMenuOpen && /* @__PURE__ */ t(Kt, {})
        ]
      }
    ),
    n && e.isQffMenuOpen && /* @__PURE__ */ t(en, { children: /* @__PURE__ */ t(Ie, {}) })
  ] });
}, Yt = (e) => () => {
  e.qffAuthData.isAuthenticated ? (e.onInteraction({
    type: "QFF Login Dropdown",
    value: e.isQffMenuOpen ? "Desktop Dropdown Collapsed" : "Desktop Dropdown Expanded"
  }), e.toggleQffMenu()) : (e.onInteraction({
    type: "QFF Login Button",
    value: "Desktop Log In Button Selected"
  }), e.onClickLogin());
}, Vt = g(74), Gt = g(300), Zt = g(92), Jt = c(T)`
  font-size: ${a("fontSizes.header.base")};
  cursor: pointer;
  display: flex;
  color: ${a("colors.white")};
  background-color: ${a("colors.brand.primary")};
  height: ${Vt};
  padding: ${a("space.4")} 0;
  align-items: center;
  justify-content: center;

  ${({ isAuthenticated: e, isOpen: n }) => O`
    min-width: ${e ? Gt : Zt};
    border-radius: ${n ? void 0 : "0 0 4px 4px"};
  `}
`, Xt = () => /* @__PURE__ */ i(u, { flexDirection: "column", alignItems: "center", children: [
  /* @__PURE__ */ t(A, { name: "close", "data-testid": "close-icon" }),
  /* @__PURE__ */ t(w, { "data-testid": "close-text", children: "Close" })
] }), Kt = () => /* @__PURE__ */ i(I, { children: [
  /* @__PURE__ */ t(A, { name: "person", "data-testid": "person-icon" }),
  /* @__PURE__ */ t(_t, {})
] }), en = c(u)`
  width: 300px;
  z-index: ${a("zIndices.phoneMenuDrawerClose")};
  position: absolute;
  flex-direction: column;
  transition: all 0.2s ease-in-out;
  background-color: ${a("colors.white")};
  box-shadow: ${a("shadows.soft")};
`, tn = c.img`
  display: inline-flex;
  width: ${g(186)};
`, nn = c(u)`
  justify-content: space-between;
  align-items: flex-end;

  @media print {
    display: none;
  }
`, an = ({
  universalNavEnabled: e = !0,
  qffLoginEnabled: n = !0,
  homepageUrl: r = ge,
  homepageLogoSrc: o = pe,
  homepageLogoLabel: l = "Qantas",
  LogoItemRenderer: s = tn,
  navEnabled: d = !0,
  arrowDirection: h = "right"
}) => {
  const { onInteraction: p } = L(), b = ce(h) ? We(h) : h;
  return /* @__PURE__ */ i(I, { children: [
    e && /* @__PURE__ */ t(V, {}),
    d && /* @__PURE__ */ i(v, { children: [
      /* @__PURE__ */ t(z, { pr: 4, children: /* @__PURE__ */ i(nn, { children: [
        /* @__PURE__ */ t(
          N,
          {
            href: r,
            mr: 4,
            my: 2,
            p: 1,
            "data-testid": "header-logo-link",
            onClick: () => {
              p({ type: "Desktop Header Logo", value: "Selected" });
            },
            children: /* @__PURE__ */ t(
              s,
              {
                src: o,
                alt: l,
                role: "img",
                "aria-label": `${l} Logo`
              }
            )
          }
        ),
        n && /* @__PURE__ */ i(
          u,
          {
            "data-print-style": "hidden",
            mb: -2,
            "data-testid": "desktop-qff-menu",
            children: [
              /* @__PURE__ */ t(Se, { arrowDirection: b }),
              /* @__PURE__ */ t(Bt, {})
            ]
          }
        )
      ] }) }),
      /* @__PURE__ */ t(vt, {})
    ] })
  ] });
}, rn = c(y)`
  overflow: scroll;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transition: all 0.2s ease-in-out;
  color: ${a("colors.white")};
  z-index: ${a("zIndices.phoneMenuDrawer")};
  right: ${a("uiStructure.phoneMenuDrawerCloseWidth")};
  background-color: ${a("colors.greys.charcoal")};
  will-change: transform;
  ${({ isOpen: e }) => e ? on : sn}
`, on = O`
  opacity: 1;
  transform: translateX(0);
`, sn = O`
  opacity: 0;
  transform: translateX(-100%);
`, ln = c(u)`
  justify-content: flex-start;
  flex-direction: column;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  color: ${a("colors.white")};
  width: ${a("uiStructure.phoneMenuDrawerCloseWidth")};
  background-color: ${a("colors.brand.primary")};
  z-index: ${a("zIndices.phoneMenuDrawer")};
  visibility: ${(e) => e.isOpen ? "visible" : "hidden"};
  opacity: ${(e) => e.isOpen ? "1" : "0"};
`, cn = c(T)`
  cursor: pointer;
  width: ${a("uiStructure.phoneMenuDrawerCloseWidth")};
  margin-right: ${a("space.1")};
  padding: ${g("22px")} 0;
  ${({ isOpen: e }) => e ? dn : un}
`, dn = O`
  opacity: 0;
`, un = O`
  opacity: 1;
`, hn = c(N)`
  font-size: ${a("fontSizes.header.base")};
  display: block;
  padding: 1rem;
  color: ${a("colors.white")};
  border-bottom: 1px solid ${a("colors.white")};
  &:hover {
    color: ${a("colors.white")};
  }
`, pn = c(w)`
  font-size: ${a("fontSizes.header.sm")};
  font-weight: ${a("fontWeights.bold")};
`, W = c(w)`
  font-size: ${a("fontSizes.header.sm")};
  font-weight: bold;
`, mn = c(N)`
  color: ${a("colors.white")};
  &:hover {
    color: ${a("colors.white")};
  }
`, fn = c(w)`
  &:hover {
    color: ${a("colors.brand.primary")};
  }
`, gn = () => {
  const { qffAuthData: e } = L();
  return /* @__PURE__ */ t($e, { ...e });
}, $e = E(
  ({
    isAuthenticated: e,
    title: n,
    firstName: r,
    lastName: o,
    membershipTier: l,
    pointsBalance: s,
    memberId: d
  }) => /* @__PURE__ */ i(I, { children: [
    e && /* @__PURE__ */ i(u, { flexDirection: "column", color: "white", justifyContent: "flex-start", children: [
      /* @__PURE__ */ i(W, { "data-hj-suppress": !0, "data-testid": "member-name-id", children: [
        Et({
          title: n,
          firstName: r,
          lastName: o
        }),
        " ",
        "(",
        d,
        ")"
      ] }),
      /* @__PURE__ */ i(u, { flexWrap: "wrap", children: [
        /* @__PURE__ */ i(pn, { "data-testid": "member-tier", children: [
          l,
          " Frequent Flyer"
        ] }),
        /* @__PURE__ */ t(W, { mx: 1, children: "-" }),
        /* @__PURE__ */ i(W, { "data-testid": "member-points-balance", children: [
          G(s),
          " points"
        ] })
      ] })
    ] }),
    !e && /* @__PURE__ */ t(u, { textAlign: "left", pr: 4, "data-testid": "not-auth-wrapper", children: /* @__PURE__ */ i(
      mn,
      {
        href: `${ct}?thirdParty=hooroos`,
        "data-testid": "sign-up-link",
        children: [
          /* @__PURE__ */ t(w, { children: "Not a member? " }),
          /* @__PURE__ */ t(fn, { children: "Join now" })
        ]
      }
    ) })
  ] })
);
$e.displayName = "QffAuthDetailsMemo";
const q = () => {
  if (typeof window > "u")
    return !1;
  const e = window.navigator.userAgent;
  return !!e.match(/iP(ad|hone|od)/i) && !!e.match(/WebKit/i) && !e.match(/CriOS/i);
}, Ce = () => {
  const e = document.querySelector("body");
  if (q() || (e.style.overflow = "hidden"), q()) {
    const n = window.scrollY;
    e.style.position = "fixed", e.style.left = "0px", e.style.right = "0px", e.style.top = `-${n}px`, e.style.bottom = "0px", e.setAttribute("data-scroll-offset", `${n}`);
  }
}, F = () => {
  const e = document.querySelector("body");
  q() || (e.style.overflow = "visible"), q() && (e.style.position = "initial", e.style.left = "initial", e.style.right = "initial", e.style.top = "initial", e.style.bottom = "initial", e.hasAttribute("data-scroll-offset") && (window.scrollTo(0, Be(e.getAttribute("data-scroll-offset"))), e.removeAttribute("data-scroll-offset")));
}, yn = ({
  qffLoginEnabled: e = !0,
  universalNavEnabled: n = !0
}) => {
  const { phoneLinks: r, isNavMenuOpen: o, toggleNavMenu: l, onInteraction: s } = L();
  x(() => (o ? Ce() : F(), () => F()), [o]);
  const d = () => {
    s({
      type: "Mobile Menu",
      value: o ? "Menu Collapsed" : "Menu Expanded"
    }), l();
  };
  return /* @__PURE__ */ i(I, { children: [
    /* @__PURE__ */ t(
      cn,
      {
        role: "button",
        isOpen: o,
        onClick: d,
        "data-testid": "menu-button",
        children: /* @__PURE__ */ t(w, { fontSize: "header.base", children: "Menu" })
      }
    ),
    /* @__PURE__ */ i(rn, { isOpen: o, children: [
      e && /* @__PURE__ */ t(y, { p: 4, borderColor: "white", borderBottom: 1, children: /* @__PURE__ */ t(gn, {}) }),
      /* @__PURE__ */ t(
        je,
        {
          phoneLinks: r,
          onInteraction: (p) => {
            s(p), l();
          }
        }
      ),
      n && /* @__PURE__ */ t(V, { variant: "mobile" })
    ] }),
    /* @__PURE__ */ t(ln, { "data-testid": "close-btn-wrapper", isOpen: o, children: /* @__PURE__ */ t(
      T,
      {
        role: "button",
        onClick: d,
        "data-testid": "close-btn",
        children: /* @__PURE__ */ t(A, { name: "close", mt: 7 })
      }
    ) })
  ] });
}, je = E(({ phoneLinks: e, onInteraction: n }) => /* @__PURE__ */ t(v, { children: e.map(({ trackingName: r, ...o }) => /* @__PURE__ */ t(
  hn,
  {
    onClick: () => n({
      type: "Site Navigation",
      value: `${r} Selected`
    }),
    ...o
  },
  r
)) }));
je.displayName = "PhoneLinks";
const bn = c(y)`
  cursor: pointer;
`, Mn = c(u)`
  position: fixed;
  top: 74px;
  right: 0;
  left: 0;
  bottom: 0;
  flex-direction: column;
  will-change: transform;
  transition: all 0.2s ease-in-out;
  background-color: ${a("colors.white")};
  z-index: ${a("zIndices.phoneMenuDrawerClose")};
  border-top: ${a("space.2")} solid ${a("colors.brand.primary")};

  transform: translateY(${(e) => e.translateY}px);

  ${a("mediaQueries.1")} {
    transition: null;
    width: 35%;
    left: auto;
    bottom: auto;
  }
`, B = c(T)`
  height: 74px;
  width: 80px;
  cursor: pointer;
  padding: ${a("space.4")} 0;
  background-color: ${a("colors.brand.primary")};
  color: ${a("colors.white")};
  align-items: center;
  justify-content: center;
`, wn = () => {
  const {
    qffAuthData: e,
    isQffMenuOpen: n,
    toggleQffMenu: r,
    onClickLogin: o,
    onInteraction: l
  } = L(), { isAuthenticated: s } = e, d = H(), [h, p] = Ze(0);
  x(() => () => F(), []), x(() => {
    const { offsetTop: m = 0 } = (d == null ? void 0 : d.current) || {};
    p(m);
  }, [d, p]);
  const b = () => {
    l({
      type: "QFF Login Dropdown",
      value: n ? "Mobile Dropdown Collapsed" : "Mobile Dropdown Expanded"
    }), n ? F() : Ce(), r();
  };
  return /* @__PURE__ */ t(y, { "data-testid": "qff-menu", ref: d, children: /* @__PURE__ */ i(bn, { children: [
    s && !n && /* @__PURE__ */ t(
      B,
      {
        role: "button",
        onClick: b,
        "data-testid": "show-details-button",
        children: /* @__PURE__ */ t(A, { name: "person" })
      }
    ),
    s && n && /* @__PURE__ */ i(I, { children: [
      /* @__PURE__ */ t(
        B,
        {
          role: "button",
          onClick: b,
          "data-testid": "close-button",
          children: /* @__PURE__ */ t(A, { name: "close" })
        }
      ),
      /* @__PURE__ */ t(
        Mn,
        {
          "data-testid": "qff-menuwrapper",
          translateY: h,
          children: /* @__PURE__ */ t(Ie, {})
        }
      )
    ] }),
    !s && /* @__PURE__ */ t(
      B,
      {
        role: "button",
        onClick: () => {
          l({
            type: "QFF Login Button",
            value: "Mobile Log In Button Selected"
          }), o();
        },
        "data-testid": "login-button",
        children: "Log in"
      }
    )
  ] }) });
}, ne = "71px", kn = ({
  universalNavEnabled: e = !0,
  qffLoginEnabled: n = !0,
  homepageUrl: r = ge,
  homepageLogoSrc: o = pe,
  homepageLogoLabel: l = "Qantas",
  LogoItemRenderer: s = Nn,
  navEnabled: d = !0,
  arrowDirection: h = "up"
}) => {
  const { onInteraction: p } = L(), b = ce(h) ? Ye(h) : h;
  return /* @__PURE__ */ i(z, { p: 0, children: [
    d && /* @__PURE__ */ i(Dn, { children: [
      /* @__PURE__ */ t(u, { alignItems: "center", children: /* @__PURE__ */ t(
        N,
        {
          href: r,
          mr: 4,
          p: 1,
          "data-testid": "header-logo-link",
          onClick: () => {
            p({ type: "Phone Header Logo", value: "Selected" });
          },
          children: /* @__PURE__ */ t(
            s,
            {
              src: o,
              alt: l,
              role: "img",
              "aria-label": `${l} Logo`
            }
          )
        }
      ) }),
      /* @__PURE__ */ i(u, { "data-print-style": "hidden", "data-testid": "phone-menus", children: [
        /* @__PURE__ */ t(
          yn,
          {
            qffLoginEnabled: n,
            universalNavEnabled: e
          }
        ),
        n && /* @__PURE__ */ t(wn, {})
      ] })
    ] }),
    n && /* @__PURE__ */ t(Se, { arrowDirection: b })
  ] });
}, Nn = c.img`
  display: inline-flex;
  clip-path: inset(0 0 -1px ${ne});
  margin-left: -${ne};
  ${a("mediaQueries.1")} {
    width: ${g("186px")};
  }
`, Dn = c(u)`
  justify-content: space-between;
  align-items: center;
  padding-left: ${a("space.4")};
  border-bottom: 1px solid ${a("colors.greys.porcelain")};
`, Oa = ({
  skipToContentUrl: e = "#content",
  ...n
}) => /* @__PURE__ */ t(kt, { ...n, children: /* @__PURE__ */ i(Ln, { "data-print-style": "no-border", children: [
  e && /* @__PURE__ */ t(N, { to: e, hidden: !0, children: "Skip Global Header to Content" }),
  /* @__PURE__ */ t(X, { xs: !0, sm: !0, children: /* @__PURE__ */ t(an, { ...n }) }),
  /* @__PURE__ */ t(X, { md: !0, lg: !0, children: /* @__PURE__ */ t(kn, { ...n }) })
] }) }), Ln = c(y)`
  top: 0;
  z-index: ${a("zIndices.header")};
  background-color: ${a("colors.white")};
`, ve = [
  {
    children: "Australia",
    href: "/hotels/australia",
    to: "/hotels/australia",
    trackingName: "Australia Destination",
    submenu: [
      {
        children: "Melbourne",
        "data-testid": "melbourne-destinations-link",
        href: "/hotels/australia/vic/melbourne",
        to: "/hotels/australia/vic/melbourne",
        trackingName: "Melbourne Destination"
      },
      {
        children: "Sydney",
        "data-testid": "sydney-destinations-link",
        href: "/hotels/australia/nsw/sydney",
        to: "/hotels/australia/nsw/sydney",
        trackingName: "Sydney Destination"
      },
      {
        children: "Brisbane",
        "data-testid": "brisbane-destinations-link",
        href: "/hotels/australia/qld/brisbane",
        to: "/hotels/australia/qld/brisbane",
        trackingName: "Brisbane Destination"
      },
      {
        children: "Perth",
        "data-testid": "perth-destinations-link",
        href: "/hotels/australia/wa/perth",
        to: "/hotels/australia/wa/perth",
        trackingName: "Perth Destination"
      },
      {
        children: "Adelaide",
        "data-testid": "adelaide-destinations-link",
        href: "/hotels/australia/sa/adelaide",
        to: "/hotels/australia/sa/adelaide",
        trackingName: "Adelaide Destination"
      },
      {
        children: "Darwin",
        "data-testid": "darwin-destinations-link",
        href: "/hotels/australia/nt/darwin",
        to: "/hotels/australia/nt/darwin",
        trackingName: "Darwin Destination"
      },
      {
        children: "Cairns",
        "data-testid": "cairns-destinations-link",
        href: "/hotels/australia/qld/cairns",
        to: "/hotels/australia/qld/cairns",
        trackingName: "Cairns Destination"
      },
      {
        children: "Surfers Paradise",
        "data-testid": "surfers-paradise-destinations-link",
        href: "/hotels/australia/qld/surfers-paradise",
        to: "/hotels/australia/qld/surfers-paradise",
        trackingName: "Surfers Paradise Destination"
      }
    ]
  },
  {
    children: "By State",
    trackingName: "By State Destination",
    submenu: [
      {
        children: "Queensland",
        href: "/hotels/australia/qld",
        to: "/hotels/australia/qld",
        trackingName: "Queensland Destination"
      },
      {
        children: "New South Wales",
        href: "/hotels/australia/nsw",
        to: "/hotels/australia/nsw",
        trackingName: "New South Wales Destination"
      },
      {
        children: "Victoria",
        href: "/hotels/australia/vic",
        to: "/hotels/australia/vic",
        trackingName: "Victoria Destination"
      },
      {
        children: "Western Australia",
        href: "/hotels/australia/wa",
        to: "/hotels/australia/wa",
        trackingName: "Western Australia Destination"
      },
      {
        children: "Northern Territory",
        href: "/hotels/australia/nt",
        to: "/hotels/australia/nt",
        trackingName: "Northern Territory Destination"
      },
      {
        children: "South Australia",
        href: "/hotels/australia/sa",
        to: "/hotels/australia/sa",
        trackingName: "South Australia Destination"
      },
      {
        children: "Tasmania",
        href: "/hotels/australia/tas",
        to: "/hotels/australia/tas",
        trackingName: "Tasmania Destination"
      },
      {
        children: "Australian Capital Territory",
        href: "/hotels/australia/act",
        to: "/hotels/australia/act",
        trackingName: "Australian Capital Territory Destination"
      }
    ]
  }
], ze = [
  {
    trackingName: "Hotels",
    href: ye,
    "data-testid": "hotels-link",
    children: "Hotels",
    rel: "noreferrer noopener",
    target: "_blank"
  },
  {
    trackingName: "Destinations",
    href: rt,
    "data-testid": "destinations-mobile-link",
    children: "Destinations",
    dropdown: ve,
    rel: "noreferrer noopener",
    target: "_blank"
  },
  {
    trackingName: "Hotels Deals",
    href: be,
    "data-testid": "deals-link",
    children: "Hotel Deals",
    rel: "noreferrer noopener",
    target: "_blank"
  },
  {
    trackingName: "Luxury Holidays",
    href: we,
    "data-testid": "luxe-link",
    children: "Luxury Holidays",
    rel: "noreferrer noopener",
    target: "_blank"
  },
  {
    trackingName: "Airbnb",
    href: fe,
    "data-testid": "airbnb-link",
    children: "Airbnb",
    rel: "noreferrer noopener",
    target: "_blank"
  }
], An = [
  ...ze,
  {
    trackingName: "Phone Contact",
    href: ke,
    "data-testid": "phone-contact-link",
    children: "Contact"
  },
  {
    trackingName: "Phone Privacy Security",
    href: st,
    "data-testid": "phone-privacy-security-link",
    children: "Privacy & Security"
  },
  {
    trackingName: "Phone Term Of Use",
    href: lt,
    "data-testid": "phone-term-of-use-link",
    children: "Terms of use"
  },
  {
    trackingName: "Phone Australian Destinations",
    href: De,
    "data-testid": "phone-australian-destinations-link",
    children: "Australian destinations"
  },
  {
    trackingName: "Phone Faqs",
    href: Ne,
    "data-testid": "phone-faqs-link",
    children: "FAQs"
  }
], Sn = [
  {
    trackingName: "My Account",
    href: dt,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-testid": "my-account-link",
    children: "My account"
  },
  {
    trackingName: "My Hotel Bookings",
    href: Me,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-testid": "my-bookings-link",
    children: "My hotel bookings"
  },
  {
    trackingName: "My Points Activity",
    href: ht,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-testid": "my-points-link",
    children: "My points activity"
  },
  {
    trackingName: "My Profile",
    href: ut,
    target: "_blank",
    rel: "noreferrer noopener",
    "data-testid": "my-profile-link",
    children: "My profile"
  }
], xn = [
  {
    trackingName: "Hotels",
    href: "/search/list",
    "data-testid": "hotels-link",
    children: "Hotels",
    usesQueryParams: !0
  },
  {
    trackingName: "Destinations",
    "data-testid": "destinations-link",
    children: "Destinations",
    href: "/hotels/australia",
    dropdown: [
      {
        children: "Australia",
        href: "/australia",
        trackingName: "Australia Destination",
        submenu: [
          {
            children: "Melbourne",
            "data-testid": "melbourne-destinations-link",
            href: "/australia/vic/melbourne",
            trackingName: "Melbourne Destination"
          },
          {
            children: "Sydney",
            "data-testid": "sydney-destinations-link",
            href: "/australia/nsw/sydney",
            trackingName: "Sydney Destination"
          }
        ]
      },
      {
        children: "By State",
        trackingName: "By State Destination",
        submenu: [
          {
            children: "Queensland",
            href: "/australia/qld",
            trackingName: "Queensland Destination"
          },
          {
            children: "New South Wales",
            href: "/australia/nsw",
            trackingName: "New South Wales Destination"
          }
        ]
      }
    ]
  },
  {
    trackingName: "Hotel Deals",
    "data-testid": "deals-link",
    children: "Hotels Deals",
    href: "/hotels/deals"
  },
  {
    trackingName: "Luxury Offers",
    "data-testid": "luxe-link",
    children: "Luxury Offers",
    href: "/hotels/luxe"
  },
  {
    trackingName: "Holiday Packages",
    "data-testid": "holiday-packages-link",
    children: "Holiday Packages",
    href: "/hotels/packages"
  },
  {
    trackingName: "Airbnb",
    "data-testid": "airbnb-link",
    target: "_blank",
    rel: "noreferrer noopener",
    children: "Airbnb",
    href: "www.airbnb.com"
  }
], In = [
  {
    trackingName: "Hotels",
    href: "/search/list",
    "data-testid": "hotels-link",
    children: "Hotels",
    usesQueryParams: !0
  },
  {
    trackingName: "Destinations",
    href: "/australia",
    "data-testid": "destinations-mobile-link",
    children: "Destinations"
  },
  {
    trackingName: "Hotel Deals",
    "data-testid": "deals-link",
    children: "Hotels Deals",
    href: "/hotels/deals"
  },
  {
    trackingName: "Luxury Offers",
    "data-testid": "luxe-link",
    children: "Luxury Offers",
    href: "/hotels/luxe"
  },
  {
    trackingName: "Holiday Packages",
    "data-testid": "holiday-packages-link",
    children: "Holiday Packages",
    href: "/hotels/packages"
  },
  {
    trackingName: "Airbnb",
    "data-testid": "airbnb-link",
    children: "Airbnb",
    href: "www.airbnb.com"
  }
], _a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NAVIGATION_DROPDOWN: ve,
  desktopDropdownLinks: xn,
  desktopLinks: ze,
  phoneDropdownLinks: In,
  phoneLinks: An,
  qffLinks: Sn
}, Symbol.toStringTag, { value: "Module" })), $n = () => /* @__PURE__ */ i(w, { display: "block", color: "white", mb: 8, "data-testid": "acknowledgement-text", children: [
  "Qantas would like to acknowledge the Traditional Custodians of the local lands and waterways on which we live, work and fly.",
  /* @__PURE__ */ t("br", {}),
  "We pay our respects to Elders past and present."
] }), Cn = c(u)`
  border-top: ${a("space.1")} solid;
  border-color: ${a("colors.brand.primary")};
  background: ${(e) => e.backgroundColor};
  padding: ${a("space.2")} 0 ${a("space.12")};
  flex-direction: column;
`, jn = c(T)`
  width: ${g("48px")};
  height: ${g("48px")};
  color: ${a("colors.greys.charcoal")};
  background-color: ${a("colors.white")};
  border: 1px solid ${a("colors.white")};
`, vn = c(N)`
  line-height: 1.5;
  font-size: ${a("fontSizes.sm")};
  padding-right: ${a("space.4")};
  color: ${a("colors.white")};
`, zn = c.img`
  height: ${g("30px")};
`, ae = c(Pe)``, Tn = ({
  disclaimerLinks: e,
  abn: n
}) => /* @__PURE__ */ i(u, { flexWrap: "wrap", children: [
  e.map((r, o) => /* @__PURE__ */ t(y, { width: ["50%", "25%"], children: /* @__PURE__ */ t(vn, { mb: 4, ...r }) }, `footer-link-${o}`)),
  /* @__PURE__ */ t(w, { color: "white", "data-testid": "abn", fontSize: "sm", children: n })
] }), En = () => window.scrollTo(0, 0), On = ({
  landingPageUrl: e,
  footerLogoSrc: n,
  footerLogoLabel: r
}) => /* @__PURE__ */ i(u, { my: 8, justifyContent: "space-between", children: [
  /* @__PURE__ */ t(N, { href: e, "data-testid": "footer-logo-link", children: /* @__PURE__ */ t(
    zn,
    {
      src: n,
      alt: "Qantas",
      role: "img",
      "aria-label": r,
      "data-testid": "footer-logo"
    }
  ) }),
  /* @__PURE__ */ t(
    jn,
    {
      mt: -44,
      onClick: En,
      "data-testid": "scroll-to-top",
      "aria-label": "Scroll to top",
      children: /* @__PURE__ */ t(A, { name: "expandLess" })
    }
  )
] }), _n = ({
  title: e,
  linkList: n = [],
  itemRenderer: r,
  onInteraction: o = () => {
  },
  onMenuClick: l = () => {
  },
  queryString: s
}) => {
  const d = (p, b, k) => {
    o({
      type: "Footer Navigation",
      value: `${p} Selected`
    }), l({
      itemText: `Footer ${p} Selected`,
      url: b ?? k ?? ""
    });
  }, h = n.map((p) => {
    const { href: b, to: k, usesQueryParams: m, trackingName: D } = p, M = m && s ? `?${s}` : "";
    return {
      ...p,
      name: String(p.children),
      href: b ? `${b}${M}` : "",
      to: k ? `${k}${M}` : "",
      onClick: () => d(D, b, k),
      color: "white",
      "data-testid": p["data-testid"]
    };
  });
  return /* @__PURE__ */ i(v, { children: [
    r && /* @__PURE__ */ i(u, { mb: 8, flexDirection: "column", width: ["50%", "25%"], children: [
      /* @__PURE__ */ t(
        ae,
        {
          title: e,
          color: "white",
          fontSize: "lg",
          mb: 0,
          regions: h
        }
      ),
      r()
    ] }),
    !r && /* @__PURE__ */ t(
      ae,
      {
        title: e,
        color: "white",
        fontSize: "lg",
        regions: h
      }
    )
  ] });
}, Qn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  person: He
}, Symbol.toStringTag, { value: "Module" })), Hn = {
  zIndices: {
    header: 100,
    stickyNavigation: 480,
    modal: 500,
    phoneMenuDrawer: 501,
    phoneMenuDrawerClose: 502,
    navigationDropdown: 503
  },
  shadows: {
    soft: "0 1px 20px rgba(0, 0, 0, 0.15)",
    modal: "0 4px 10px 0 rgba(0, 0, 0, 0.1)"
  },
  uiStructure: {
    phoneMenuDrawerCloseWidth: g("64px")
  },
  fontSizes: {
    // TODO: unify hotels & self-service font sizes and remove fontSizes.header.* tokens
    header: {
      xs: g("15px"),
      sm: g("16px"),
      base: g("18px"),
      md: g("20px"),
      lg: g("24px"),
      xl: g("32px"),
      "2xl": g("34px"),
      "3xl": g("36px"),
      "4xl": g("46px")
    }
  }
}, qn = Qe(
  Hn,
  J,
  // lodash.merge does not know how to merge modules
  {
    icons: {
      ...J.icons,
      ...Qn
    }
  }
), Qa = ({
  landingPageUrl: e,
  disclaimerLinks: n,
  abn: r,
  footerLogoSrc: o,
  footerLogoLabel: l,
  links: s,
  backgroundColor: d = qn.colors.greys.charcoal,
  onInteraction: h = () => {
  },
  onMenuClick: p = () => {
  },
  queryString: b
}) => /* @__PURE__ */ t(Cn, { backgroundColor: d, children: /* @__PURE__ */ i(z, { children: [
  /* @__PURE__ */ t(
    On,
    {
      landingPageUrl: e,
      footerLogoSrc: o,
      footerLogoLabel: l
    }
  ),
  /* @__PURE__ */ t(u, { flexWrap: "wrap", children: s.map((k, m) => /* @__PURE__ */ t(
    _n,
    {
      onInteraction: h,
      onMenuClick: p,
      queryString: b,
      ...k
    },
    `footer-list-${m}`
  )) }),
  /* @__PURE__ */ t($n, {}),
  /* @__PURE__ */ t(Tn, { disclaimerLinks: n, abn: r })
] }) }), Fn = [
  {
    trackingName: "Manage bookings",
    href: Me,
    "data-testid": "manage-hotels-bookings",
    children: "Manage Hotels Bookings"
  },
  {
    trackingName: "FAQs",
    href: Ne,
    "data-testid": "faqs-link",
    children: "FAQs"
  },
  {
    trackingName: "Contact Us",
    href: ke,
    "data-testid": "contact-link",
    children: "Contact Us"
  }
], Pn = [
  {
    trackingName: "Privacy and security",
    href: ot,
    "data-testid": "privacy-security-link",
    children: "Privacy & Security"
  },
  {
    trackingName: "Terms of use",
    href: it,
    "data-testid": "term-of-use-link",
    children: "Terms of use"
  }
], Un = [
  {
    trackingName: "Hotels",
    href: ye,
    "data-testid": "hotels-link",
    children: "Hotels",
    usesQueryParams: !0
  },
  {
    trackingName: "Destinations",
    href: De,
    "data-testid": "destination-link",
    children: "Destinations"
  },
  {
    trackingName: "Hotels Deals",
    href: be,
    "data-testid": "deals-link",
    children: "Hotel Deals"
  },
  {
    trackingName: "Luxury Holidays",
    href: we,
    "data-testid": "luxe-link",
    children: "Luxury Holidays",
    rel: "noreferrer noopener",
    target: "_blank"
  },
  {
    trackingName: "Airbnb",
    href: fe,
    "data-testid": "airbnb-link",
    children: "Airbnb",
    rel: "noreferrer noopener",
    target: "_blank"
  }
], Rn = [
  {
    children: "Melbourne",
    "data-testid": "melbourne-destinations-link",
    href: `${f}/hotels/australia/vic/melbourne`,
    trackingName: "Melbourne Destination"
  },
  {
    children: "Sydney",
    "data-testid": "sydney-destinations-link",
    href: `${f}/hotels/australia/nsw/sydney`,
    trackingName: "Sydney Destination"
  },
  {
    children: "Brisbane",
    "data-testid": "brisbane-destinations-link",
    href: `${f}/hotels/australia/qld/brisbane`,
    trackingName: "Brisbane Destination"
  },
  {
    children: "Perth",
    "data-testid": "perth-destinations-link",
    href: `${f}/hotels/australia/wa/perth`,
    trackingName: "Perth Destination"
  },
  {
    children: "Adelaide",
    "data-testid": "adelaide-destinations-link",
    href: `${f}/hotels/australia/sa/adelaide`,
    trackingName: "Adelaide Destination"
  },
  {
    children: "Darwin",
    "data-testid": "darwin-destinations-link",
    href: `${f}/hotels/australia/nt/darwin`,
    trackingName: "Darwin Destination"
  },
  {
    children: "Cairns",
    "data-testid": "cairns-destinations-link",
    href: `${f}/hotels/australia/qld/cairns`,
    trackingName: "Cairns Destination"
  },
  {
    children: "Surfers Paradise",
    "data-testid": "surfers-paradise-destinations-link",
    href: `${f}/hotels/australia/qld/surfers-paradise`,
    trackingName: "Surfers Paradise Destination"
  }
], Wn = [
  {
    children: "Queensland",
    href: `${f}/hotels/australia/qld`,
    trackingName: "Queensland Destination"
  },
  {
    children: "New South Wales",
    href: `${f}/hotels/australia/nsw`,
    trackingName: "New South Wales Destination"
  },
  {
    children: "Victoria",
    href: `${f}/hotels/australia/vic`,
    trackingName: "Victoria Destination",
    "data-testid": "destination-victoria"
  },
  {
    children: "Western Australia",
    href: `${f}/hotels/australia/wa`,
    trackingName: "Western Australia Destination"
  },
  {
    children: "Northern Territory",
    href: `${f}/hotels/australia/nt`,
    trackingName: "Northern Territory Destination"
  },
  {
    children: "South Australia",
    href: `${f}/hotels/australia/sa`,
    trackingName: "South Australia Destination"
  },
  {
    children: "Tasmania",
    href: `${f}/hotels/australia/tas`,
    trackingName: "Tasmania Destination"
  },
  {
    children: "Australian Capital Territory",
    href: `${f}/hotels/australia/act`,
    trackingName: "Australian Capital Territory Destination"
  }
], Ha = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AustraliaDestinationCitiesLinks: Rn,
  AustraliaDestinationStatesLinks: Wn,
  DisclaimerLinks: Pn,
  HotelsLinks: Un,
  SupportLinks: Fn
}, Symbol.toStringTag, { value: "Module" })), Bn = "data:image/svg+xml;base64,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", Yn = c(y)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${a("colors.greys.porcelain")};
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 34%,
    rgb(247, 247, 247) 100%
  );
`, Vn = c.img`
  display: block;
  height: auto;
  width: 75px;
  &,
  .gm-style & {
    max-width: 50%;
  }
`, Te = he(({ alt: e, ...n }, r) => /* @__PURE__ */ t(Yn, { ref: r, ...n, children: /* @__PURE__ */ t(Vn, { src: Bn, alt: e }) }));
Te.displayName = "ImageFallback";
const Gn = me`
 0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`, Zn = c(y)`
  background-color: ${a("colors.greys.alto")};
  animation: ${Gn} 2s ease-in-out infinite;
`, Jn = (e) => /* @__PURE__ */ t(ie, { ...e }), Ee = he(({ width: e, height: n, cover: r = !0 }, o) => !e && !n || !r ? /* @__PURE__ */ t(Jn, { ref: o, size: 12, color: "greys.steel" }) : /* @__PURE__ */ t(Zn, { ...{
  width: e ?? "100%",
  height: n ?? "100%"
}, "data-testid": "shimmer" }));
Ee.displayName = "ImageLoadingIndicator";
const Xn = me`
  from { opacity: 0; }
  to   { opacity: 1; }
`, Kn = c(y)`
  overflow: hidden;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`, ea = c.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: ${(e) => e.cover ? "cover" : "contain"};
  &[data-animate] {
    animation: ${Xn} 250ms;
  }
`, ta = ({
  src: e,
  srcSet: n,
  alt: r,
  cover: o = !0,
  animate: l = !1,
  ...s
}) => /* @__PURE__ */ t(Kn, { "data-testid": "wrapper", ...s, children: /* @__PURE__ */ t(
  ea,
  {
    src: e,
    srcSet: n,
    alt: r,
    cover: o,
    "data-animate": l ? !0 : void 0,
    "data-testid": "image-inner"
  }
) }), Y = {
  isLoading: !1,
  displayedLoading: !1,
  loadedImg: void 0,
  error: ""
}, na = (e = Y, n) => {
  switch (n.type) {
    case "reset":
      return { ...Y };
    case "fetching":
      return { ...e, isLoading: !0, displayedLoading: !0, error: "" };
    case "error":
      return { ...e, isLoading: !1, error: n.error.message };
    case "success":
      return {
        ...e,
        isLoading: !1,
        error: "",
        loadedImg: et(n.payload.img, [
          "src",
          "alt",
          "srcSet",
          "naturalWidth",
          "naturalHeight"
        ])
      };
    default:
      return e;
  }
}, aa = () => Promise.resolve(), ra = ({
  src: e,
  srcSet: n,
  alt: r,
  onLoad: o
}) => {
  const [l, s] = de(na, Y), d = H(!1), h = H(!0);
  return x(() => {
    let p;
    const b = async () => new Promise((m, D) => {
      const M = new Image(), $ = async () => {
        if (h.current) {
          M.decode || (M.decode = aa);
          try {
            await M.decode(), m(M);
          } catch {
            D(
              new Error("An Error occurred while trying to decode an image")
            );
          } finally {
            o && o(M);
          }
        }
      }, P = () => D(
        new Error("An Error occurred while trying to download an image")
      );
      M.onload = $, M.onerror = P, M.src = e, M.alt = r, n && (M.srcSet = n);
    }), k = async () => {
      p = setTimeout(() => {
        d.current || s({ type: "fetching" });
      }, 500);
      try {
        const m = await b();
        s({ type: "success", payload: { img: m } });
      } catch (m) {
        const D = m instanceof Error ? m.message : String(m);
        s({ type: "error", error: { message: D } });
      } finally {
        d.current = !0;
      }
    };
    return e || n ? (h.current = !0, d.current = !1, s({ type: "reset" }), k()) : s({
      type: "error",
      error: new Error("no src or srcSet provided.")
    }), () => {
      clearTimeout(p), h.current = !1;
    };
  }, [o, e, n, r]), l;
}, Oe = ({
  src: e,
  alt: n,
  srcSet: r,
  onLoad: o,
  width: l,
  height: s,
  cover: d = !0,
  ...h
}) => {
  const { isLoading: p, displayedLoading: b, error: k, loadedImg: m } = ra({
    src: e,
    alt: n,
    srcSet: r,
    onLoad: o
  }), D = m && (!!m.src || !!m.srcSet), M = !!l || !!s;
  return !k && !p && !D ? /* @__PURE__ */ t(y, { width: l, height: s, "data-testid": "placeholder" }) : p ? /* @__PURE__ */ t(Ee, { ...h, width: l, height: s }) : k ? /* @__PURE__ */ t(Te, { ...h, width: l, height: s }) : m && D ? /* @__PURE__ */ t(
    ta,
    {
      ...h,
      src: m.src,
      alt: m.alt,
      srcSet: m.srcSet,
      width: M ? l || "100%" : m.naturalWidth,
      height: M ? s || "100%" : m.naturalHeight,
      animate: b,
      cover: d
    }
  ) : null;
}, re = "200px", oa = ({
  width: e,
  height: n,
  cover: r = !0,
  ...o
}) => {
  const [l, s] = Ke({
    triggerOnce: !0,
    rootMargin: `${re} 0px ${re} 0px`
  });
  return s ? /* @__PURE__ */ t(Oe, { cover: r, width: e, height: n, ...o }) : /* @__PURE__ */ t(y, { ref: l, width: e, height: n });
}, ia = E(
  ({ alt: e = "alt", lazy: n = !1, cover: r = !0, ...o }) => /* @__PURE__ */ t(n ? oa : Oe, { alt: e, cover: r, ...o })
);
ia.displayName = "Image";
const C = ({ error: e, ...n }) => e ? /* @__PURE__ */ t(
  y,
  {
    bg: "ui.errorBackground",
    color: "greys.steel",
    fontSize: ["sm", "base"],
    p: 2,
    "data-testid": "input-error",
    ...n,
    children: e.message
  }
) : null, sa = c(Ue)`
  font-size: ${a("fontSizes.base")};
  color: ${a("colors.greys.steel")};
`, j = ({
  htmlFor: e,
  children: n,
  mb: r,
  ...o
}) => /* @__PURE__ */ t(y, { ...o, children: /* @__PURE__ */ t(sa, { htmlFor: e, mb: r, "data-testid": "field-label", children: n }) }), la = [
  {
    title: "Morning (09:00 - 12:00)",
    value: 9
  },
  {
    title: "Early afternoon (12:00 - 15:00)",
    value: 12
  },
  {
    title: "Last afternoon (15:00 - 19:00)",
    value: 15
  }
], _e = /* @__PURE__ */ new Date();
_e.setHours(0, 0, 0, 0);
const ca = Array.from({ length: 6 }, (e, n) => {
  const r = nt(_e, n);
  return {
    title: (n === 0 ? "Today - " : "") + at(r, "iiii (yyyy-MM-dd)"),
    value: r.toISOString()
  };
}), oe = c(Re)`
  ::-ms-expand {
    display: none;
  }
`, da = /^[a-z .'-\s]+$/i, ua = /^[0-9\s+-]+$/, ha = /(^$|^(([0-9]){10}|([0-9]){1,7})$)/, pa = ({
  register: e,
  errors: n,
  prefilledDetails: { fullName: r, phoneNumber: o, qffNumber: l } = {}
}) => /* @__PURE__ */ i(v, { children: [
  /* @__PURE__ */ t(Q.h3, { fontSize: "xl", mb: 6, children: "How we'll contact you" }),
  /* @__PURE__ */ t(Q.h4, { fontSize: "md", children: "Your details" }),
  /* @__PURE__ */ i(
    u,
    {
      flexDirection: ["column", "row"],
      flexWrap: "wrap",
      borderBottom: 1,
      borderColor: "greys.alto",
      pb: 5,
      mb: 8,
      children: [
        /* @__PURE__ */ i(
          j,
          {
            htmlFor: "fullName",
            flex: "0 0 50%",
            mb: [5, 3],
            pr: [0, 4],
            "data-testid": "full-name-input",
            children: [
              "Name",
              /* @__PURE__ */ t(
                U,
                {
                  id: "fullName",
                  defaultValue: r,
                  ...e("fullName", {
                    required: "Please enter your name",
                    pattern: {
                      value: da,
                      message: "Fullname cannot contain numerical or non-English characters"
                    }
                  }),
                  error: !!n.fullName
                }
              ),
              /* @__PURE__ */ t(C, { error: n.fullName, "data-testid": "full-name-error" })
            ]
          }
        ),
        /* @__PURE__ */ i(
          j,
          {
            htmlFor: "phoneNumber",
            flex: "0 0 50%",
            mb: [5, 3],
            pr: [0, 4],
            "data-testid": "phone-number-input",
            children: [
              "Phone number",
              /* @__PURE__ */ t(
                U,
                {
                  id: "phoneNumber",
                  defaultValue: o,
                  ...e("phoneNumber", {
                    required: "Please enter your phone number",
                    pattern: {
                      value: ua,
                      message: "Please enter only numbers, spaces, + or -"
                    }
                  }),
                  error: !!n.phoneNumber
                }
              ),
              /* @__PURE__ */ t(
                C,
                {
                  error: n.phoneNumber,
                  "data-testid": "phone-number-error"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ i(
          j,
          {
            htmlFor: "qffNumber",
            flex: "0 0 50%",
            mb: [5, 3],
            pr: [0, 4],
            "data-testid": "qff-number-input",
            children: [
              /* @__PURE__ */ i(u, { justifyContent: "space-between", alignItems: "center", children: [
                "Qantas Frequent Flyer number",
                /* @__PURE__ */ t(w, { color: "greys.dusty", fontSize: "xs", children: "optional" })
              ] }),
              /* @__PURE__ */ t(
                U,
                {
                  id: "qffNumber",
                  defaultValue: l,
                  ...e("qffNumber", {
                    pattern: {
                      value: ha,
                      message: "Please enter a valid Frequent Flyer Number"
                    }
                  }),
                  error: !!n.qffNumber
                }
              ),
              /* @__PURE__ */ t(C, { error: n.qffNumber, "data-testid": "qff-number-error" }),
              /* @__PURE__ */ t(w, { children: "So we know how to award your Qantas Points" })
            ]
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ t(Q.h4, { fontSize: "md", children: "When's the best time to call?" }),
  /* @__PURE__ */ i(u, { flexDirection: ["column", "row"], flexWrap: "wrap", mb: 5, children: [
    /* @__PURE__ */ i(
      j,
      {
        htmlFor: "callbackTime",
        flex: "0 0 50%",
        mb: [5, 3],
        pr: [0, 4],
        "data-testid": "callback-time-select",
        children: [
          /* @__PURE__ */ i(u, { justifyContent: "space-between", alignItems: "center", children: [
            "Time",
            /* @__PURE__ */ t(w, { color: "greys.dusty", fontSize: "xs", children: "optional" })
          ] }),
          /* @__PURE__ */ i(
            oe,
            {
              id: "callbackTime",
              ...e("callbackTime"),
              error: !!n.callbackTime,
              children: [
                /* @__PURE__ */ t("option", { value: "", children: "Select" }),
                la.map((s) => /* @__PURE__ */ t("option", { value: s.value, children: s.title }, s.title))
              ]
            }
          ),
          /* @__PURE__ */ t(
            C,
            {
              error: n.callbackTime,
              "data-testid": "callback-time-error"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(
      j,
      {
        htmlFor: "callbackDate",
        flex: "0 0 50%",
        mb: [5, 3],
        pr: [0, 4],
        "data-testid": "callback-date-select",
        children: [
          /* @__PURE__ */ i(u, { justifyContent: "space-between", alignItems: "center", children: [
            "Date",
            /* @__PURE__ */ t(w, { color: "greys.dusty", fontSize: "xs", children: "optional" })
          ] }),
          /* @__PURE__ */ i(
            oe,
            {
              id: "callbackDate",
              ...e("callbackDate"),
              error: !!n.callbackDate,
              children: [
                /* @__PURE__ */ t("option", { value: "", children: "Select" }),
                ca.map((s) => /* @__PURE__ */ t("option", { value: s.value, children: s.title }, s.title))
              ]
            }
          ),
          /* @__PURE__ */ t(
            C,
            {
              error: n.callbackDate,
              "data-testid": "callback-date-error"
            }
          )
        ]
      }
    )
  ] }),
  /* @__PURE__ */ t(
    se,
    {
      type: "submit",
      variant: "primary",
      width: ["100%", "220px"],
      "data-testid": "submit-callback-button",
      mb: 8,
      children: "Submit"
    }
  ),
  /* @__PURE__ */ t(w, { display: "block", children: "We will only use your information for the purpose of processing this enquiry" })
] }), ma = ({ onClose: e }) => /* @__PURE__ */ i(v, { children: [
  /* @__PURE__ */ t(Q.h3, { fontSize: "xl", mb: 6, children: "Thank you for your interest" }),
  /* @__PURE__ */ i(
    w,
    {
      display: "block",
      fontSize: "base",
      mb: 5,
      "data-testid": "call-center-number",
      children: [
        "One of our customer service representatives will be in touch shortly. If you have any questions please call ",
        /* @__PURE__ */ t(N, { href: "tel:137066", children: "13 70 66" }),
        "."
      ]
    }
  ),
  /* @__PURE__ */ t(
    se,
    {
      variant: "primary",
      width: ["100%", "220px"],
      onClick: () => e(),
      "data-testid": "close-confirmation",
      children: "Close"
    }
  )
] }), fa = c("form")`
  position: relative;
`, ga = c(u)`
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.7);
`, qa = ({
  onSubmit: e = S,
  onClose: n = S,
  isSubmitting: r = !1,
  isComplete: o = !1,
  prefilledDetails: l
}) => {
  const {
    handleSubmit: s,
    register: d,
    formState: { errors: h }
  } = tt({
    mode: "onBlur"
  });
  return /* @__PURE__ */ i(fa, { onSubmit: s(e), children: [
    r && /* @__PURE__ */ t(ga, { children: /* @__PURE__ */ t(ie, { color: "greys.steel" }) }),
    !o && /* @__PURE__ */ t(
      pa,
      {
        register: d,
        errors: h,
        prefilledDetails: l
      }
    ),
    o && /* @__PURE__ */ t(ma, { onClose: n })
  ] });
};
export {
  C as FieldError,
  j as FieldLabel,
  Qa as Footer,
  Oa as Header,
  ia as Image,
  _n as Links,
  qa as RequestCallbackForm,
  Ce as fixBodyScroll,
  Ha as footerConfigDefaults,
  _a as headerConfigDefaults,
  q as isIOSDevice,
  Bn as placeholder,
  qn as theme,
  F as unfixBodyScroll
};
//# sourceMappingURL=qga-components.es.js.map
